const a = {
  value: "36rem"
};
export {
  a as default,
  a as t_global_breakpoint_sm
};
